import { IOptions } from './namespace';

export const initialOptions: IOptions = {
  isDouble: false,
  min: 0,
  max: 100,
  from: 0,
  to: 0,
  step: 1,
};



// WEBPACK FOOTER //
// ./components/model/initial.ts